import { toast } from "react-toastify";
import api from "../../../../../../features/auth/axiosConfig";
import { generatePdf } from "./pdfUtils";
import { buildInvoiceHtml } from "./invoiceTemplate";

/**
 * Hook for sending invoice emails.
 * @param defaultOrder - optional order object (you can still pass a custom one later)
 */
export function useInvoiceEmail(defaultOrder?: any) {
  const sendInvoiceEmail = async (email: string, customOrder?: any) => {
    const toastId = toast.loading("Preparing invoice...");

    try {
      if (!email) throw new Error("Email is required");

      // Use custom order if passed, else fallback to defaultOrder
      const order = customOrder || defaultOrder;
      if (!order) throw new Error("Order data is missing");

      const htmlContent = buildInvoiceHtml({
        CustomerName: order.CustomerName || "Valued Customer",
        Orderdate: order.Orderdate,
        Products: order.Products,
        totalAmount: order.totalAmount,
      });

      const pdfBlob = await generatePdf(htmlContent);

      const formData = new FormData();
      formData.append("file", pdfBlob, "Invoice.pdf");
      formData.append("receiver_email", email);
      formData.append("cnames", order.CustomerName || "Valued Customer");
      formData.append("id", order.Orderid);
      formData.append("TotalAmount", String(order.totalAmount ?? 0));
      formData.append("ReceivedAmount", String(order.payments?.[0]?.ReceivedAmount ?? 0));
      formData.append("RemainingAmount", String(order.RemainingAmount ?? 0));

      await api.post(`/app/v1/pos/orders_send_email`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      toast.dismiss(toastId);
      toast.success("Mail sent successfully", { autoClose: 1000, theme: "colored" });
    } catch (error) {
      console.error("Error sending invoice email:", error);
      toast.dismiss(toastId);
      toast.error("Failed to send email.", { autoClose: 2000, theme: "colored" });
    }
  };

  return { sendInvoiceEmail };
}
